module.exports = __webpack_public_path__ + "static/media/m_box.6249cdd4.png";